import { render, staticRenderFns } from "./my.vue?vue&type=template&id=beab4850&scoped=true&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beab4850",
  null
  
)

export default component.exports